import OProjectNavDeveloper from './o-project-nav-developer.vue'

export default OProjectNavDeveloper
